export default {
  getMeasurePayment (that) {
    const data = {
      productCode: that.$store.state.order.productId,
      sex: that.sex,
      age: that.$store.getters.ageFromBirthday,
      payType: that.paymentPeriod,
      durationPeriodValue: that.$store.state.order.insurancePeriod,
      durationPeriodType: '1',
      coverageMultiples: that.$store.state.order.insuranceAmount
    }
    if (that.$store.state.order.insurancePeriod === '60' ||
      that.$store.state.order.insurancePeriod === '65' ||
      that.$store.state.order.insurancePeriod === '70') {
      data.durationPeriodType = '2'
    }
    let queryString = '?sex=' + data.sex +
                      '&age=' + data.age +
                      '&payType=' + data.payType +
                      '&durationPeriodValue=' + data.durationPeriodValue +
                      '&durationPeriodType=' + data.durationPeriodType +
                      '&productCode=' + data.productCode +
                      '&innerCode=' + that.$route.params.userId +
                      '&utm_source=' + (that.$route.query.utm_source || '') +
                      '&calculationCode=' + (that.$route.query.calculationCode || '') +
                      '&coverageMultiples=' + data.coverageMultiples
    that.$http.get('/api/illness/getFee' + queryString).then(response => {
      that.$store.commit('updateMeasurePayment', response.data)
    })
  },
  getPaymentByIDNumber (that) {
    const data = {
      productCode: that.$store.state.order.productId,
      sex: that.$store.getters.sexFromIDNumber,
      age: that.$store.getters.ageFromIDNumber,
      payType: that.paymentPeriod,
      durationPeriodValue: that.$store.state.order.insurancePeriod,
      durationPeriodType: '1'
    }
    if (that.$store.state.order.insurancePeriod === '60' ||
      that.$store.state.order.insurancePeriod === '65' ||
      that.$store.state.order.insurancePeriod === '70') {
      data.durationPeriodType = '2'
    }
    let queryString = '?sex=' + data.sex +
                      '&age=' + data.age +
                      '&payType=' + data.payType +
                      '&durationPeriodValue=' + data.durationPeriodValue +
                      '&durationPeriodType=' + data.durationPeriodType +
                      '&productCode=' + data.productCode +
                      '&innerCode=' + that.$route.params.userId +
                      '&utm_source=' + that.$route.query.utm_source
    that.$http.get('/api/illness/getFee' + queryString).then(response => {
      that.$store.commit('updatePaymentByIDNumber', response.data)
    })
  },
  getH5Configuration (that) {
    return new Promise((resolve, reject) => {
      that.$http.get('/api/channel/hqdqx/queryCustomInfo/' + that.$store.state.order.userId + '/' + that.$store.state.order.productId).then(response => {
        for (let i in response.data) {
          that.$set(that.$store.state.h5.configuration, i, response.data[i])
        }
        if (response.data === null) {
          that.$set(that.$store.state.h5.configuration, 'isNull', true)
        } else {
          that.$set(that.$store.state.h5.configuration, 'isNull', false)
        }
        resolve(response.data)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js